<div class="spinner-wrapper" *ngIf="showLoader">
  <mat-spinner></mat-spinner>
</div>
<div class="container new-design-wrapper">
  <form action="">
  </form>
  <div class="new-design-wrapper__detail">
    <h3>Design: {{systemsDesign?.hvac_dsn_descrpt}}</h3>
    <h3>System: {{systemName}}</h3>
    <h4>ID Design: {{systemsDesign?.hvac_design_id}}</h4>
    <h4>ID System: {{system_id}}</h4>
    <button mat-flat-button color="accent" class="back-btn" [routerLink]="['/new-system']">
      Back to the System
    </button>
  </div>
  <form focusInvalidInput class="form" #newSystemDesignForm="ngForm"
    (ngSubmit)="newSystemDesignForm.form.valid && addRoom()">
    <section class="example-section">
      <mat-checkbox (change)="    addFile = !addFile;" [checked]="addFile">
        Update room by room file instead
      </mat-checkbox>
    </section>

    <div class="d-flex flex-wrap row mt-5" *ngIf="!addFile ; else uploadFileBlock">

      <div class="d-flex flex-wrap row mt-5" style="margin-bottom:10px;">
        Total CFM of Rooms: {{roomTotal}}
        <br>CFM Difference : {{remainingCFM}}
      </div>

      <div class="d-flex mb-3 col-md-6 flex-column px-3">
        <div class="d-flex">
          <p class="design-overview-wrapper__item__title">Room Description<i style="color:red;">*</i></p>
        </div>
        <mat-form-field appearance="fill" floatLabel="always">
          <input matInput type="text" [(ngModel)]="room.room_descr" maxlength="9" [ngModelOptions]="{standalone: false}"
            name="room_descr" class="example-right-align" placeholder="Condenser Manufacturer" #room_descr='ngModel'
            [required]="isRequired()">
          <span class="input-group-addon"></span>
        </mat-form-field>
        <div class="error-wrapper">
          <mat-error *ngIf="newSystemDesignForm.submitted&& room_descr.errors?.required"> Room Description required
          </mat-error>
        </div>
      </div>
      <div class="d-flex mb-3 col-md-6 flex-column px-3">
        <p class="design-overview-wrapper__item__title">Design Airflow CFM<i style="color:red;">*</i></p>
        <mat-form-field appearance="fill" floatLabel="always">
          <input matInput type="number" [(ngModel)]="room.dsh_heat_flow" maxlength="9"
            [ngModelOptions]="{standalone: false}" name="dsh_heat_flow" class="example-right-align"
            placeholder="Condenser Manufacturer" #dsh_heat_flow='ngModel' [required]="isRequired()">
          <span class="input-group-addon">CFM</span>
        </mat-form-field>
        <div class="error-wrapper">
          <mat-error *ngIf="newSystemDesignForm.submitted && dsh_heat_flow.errors?.required"> Design Airflow CFM
            required
          </mat-error>
        </div>
      </div>
    </div>
    <ng-template #uploadFileBlock>
      <div class="d-flex mb-3 col-md-6 flex-column">
        <div class="block pt-3 pb-3">
          <div class="custom-input-file">
            <input type="file" #file class="hide" ngModel accept="image/*" name="newProfileImage"
              (change)="uploadFile(file.files)" />
            <span class="file-name">{{selectedFileName}}</span>
            <span class="browse-btn">Browse</span>
          </div>
        </div>
      </div>
    </ng-template>
    <button mat-flat-button color="accent" class="add">
      Add
    </button>
    <button *ngIf="!addDone" mat-flat-button color="primary" class="finish" (click)="checkRooms()">
      FINISH
    </button>
    <button *ngIf="addDone" mat-flat-button color="primary" class="finish" (click)="checkRooms()">
      FINISH
    </button>
  </form>
  <div *ngIf="!addFile">
    <form focusInvalidInput class="form" #newSystemDesignForm="ngForm">
      <div class="d-flex flex-wrap row mt-5" *ngFor="let room of sys_rooms">
        <div class="d-flex mb-3 col-md-6 flex-column px-3">
          <div class="d-flex">
            <p class="design-overview-wrapper__item__title">Room Description<i style="color:red;">*</i></p>
          </div>
          {{room.room_descr}}
        </div>
        <div class="d-flex mb-3 col-md-6 flex-column px-3">
          <p class="design-overview-wrapper__item__title">Design Airflow CFM<i style="color:red;">*</i></p>
          {{room.dsh_heat_flow}}
        </div>
        <button mat-flat-button color="accent" class="add" (click)="editRoom(room)">
          Edit
        </button>
        <button mat-flat-button color="primary" class="finish" (click)="deleteRoom(room)" >
          Delete
        </button>
      </div>


    </form>
  </div>


</div>
